import { render, staticRenderFns } from "./ProjectData.vue?vue&type=template&id=f5ee24a2&scoped=true"
import script from "./ProjectData.vue?vue&type=script&lang=js"
export * from "./ProjectData.vue?vue&type=script&lang=js"
import style0 from "./ProjectData.vue?vue&type=style&index=0&id=f5ee24a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ee24a2",
  null
  
)

export default component.exports